SNI.Application.addModule('launch-lead-video', (context) => {
  return {
    behaviors: ['lead-video-launcher']
  };
});
